import { RouteAddress } from "../../types"
import { PendingMove } from "./types"

export interface MoveOrdersDraft {
	stopsByRoute: Record<string, RouteAddress[]>
	pendingMoves: [string, PendingMove][]
	positionOverrides: Record<string, number>
}

export const draftKey = (
	business: string,
	contract: string,
	date: string
): string => `moveOrdersDraft:${business}:${contract}:${date}`

// localStorage can throw (quota, private browsing) — losing the draft-recovery
// safety net silently isn't worth surfacing an error for.
export function loadDraft(key: string): MoveOrdersDraft | null {
	try {
		const raw = localStorage.getItem(key)
		return raw ? JSON.parse(raw) : null
	} catch {
		return null
	}
}

export function saveDraft(key: string, draft: MoveOrdersDraft) {
	try {
		localStorage.setItem(key, JSON.stringify(draft))
	} catch {
		// ignore — see loadDraft
	}
}

export function clearDraft(key: string) {
	try {
		localStorage.removeItem(key)
	} catch {
		// ignore — see loadDraft
	}
}
